module.exports = __webpack_public_path__ + "img/17.aa773464.gif";